// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Rd528S9rl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/Search.scss
// module id = 902
// module chunks = 0